<template>
  <transition name="dialog-fade" @after-enter="afterEnter" @after-leave="afterLeave">
    <div v-if="dialogVisible" class="image-dialog-wrapper" @click.self="handleWrapperClick">
      <div class="image-dialog" :style="{ width: dialogWidth }">
        <div class="dialog-content">
          <el-image :src="imageUrl" fit="contain" :style="imageStyle">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
              <p>图片加载失败</p>
            </div>
          </el-image>
          <span class="dialog-footer">
            <i class="el-icon-circle-close close-icon" @click="closeDialog"></i>
          </span>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ImagePreviewDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    imageUrl: {
      type: String,
      default: ''
    },
    width: {
      type: [String, Number],
      // default: '600px'
    },
    height: {
      type: [String, Number],
      // default: '500px'
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    },
    dialogWidth() {
      return typeof this.width === 'number' ? `${this.width}px` : this.width;
    },
    imageStyle() {
      const height = typeof this.height === 'number' ? `${this.height}px` : this.height;
      return {
        height: height,
        borderRadius: '10px'
      };
    }
  },
  methods: {
    closeDialog() {
      this.$emit('update:visible', false);
      this.$emit('close');
    },
    handleWrapperClick() {
      if (this.closeOnClickModal) {
        this.closeDialog();
      }
    },
    afterEnter() {
      this.$emit('opened');
    },
    afterLeave() {
      this.$emit('closed');
    },
    handleKeydown(e) {
      if (e.keyCode === 27) { // ESC key
        this.closeDialog();
      }
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
  }
}
</script>

<style lang="scss" scoped>
// Dialog 动画
.dialog-fade-enter-active {
  animation: dialog-fade-in 0.3s;
}

.dialog-fade-leave-active {
  animation: dialog-fade-out 0.3s;
}

@keyframes dialog-fade-in {
  0% {
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
  100% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

@keyframes dialog-fade-out {
  0% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  100% {
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
}

// Dialog 包装器样式
.image-dialog-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  z-index: 2001;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

// Dialog 主体样式
.image-dialog {
  position: relative;
  margin: 15vh auto 50px;
  background: transparent;
  border-radius: 2px;
  box-shadow: none;
  width: 50%;
  max-width: 90%;
}

.dialog-content {
  text-align: center;
  position: relative;
  border-radius: 10px;

  .image-slot {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 200px;
    color: #909399;

    i {
      font-size: 40px;
      margin-bottom: 10px;
    }
  }
}

.dialog-footer {
  position: absolute;
  bottom: -80px;
  left: 50%;
  transform: translateX(-50%);

  .close-icon {
    font-size: 40px;
    background-color: rgba(0, 0, 0, .2);
    border-radius: 50%;
    color: #fff;
    cursor: pointer;

    &:hover {
      opacity: .8;
    }
  }
}
</style>